import {DecimalPipe} from '@angular/common';
import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Observable} from 'rxjs';
import {ApiModulesService} from 'src/app/api-modules.service';
import {NgbdSortableHeader, SortEvent} from 'src/app/shared/directives/NgbdSortableHeader';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {
    public selected = [];
    public searchText;
    public editID: any;
    visible: any = true;
    visibleAdd: any = true;
    public username = [];

    countries = [];
    data: any[] = [];
    filterParams: any = {};
    sortField: any = '';
    sortOrder: any = '';
    searchQuery: any = '';

    // Pagination
    currentPage = 1;
    total = 0;

    constructor(private apiModulesService: ApiModulesService) {

    }

    @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

    onSort({column, direction}: SortEvent) {

        this.headers.forEach((header) => {
            if (header.sortable !== column) {
                header.direction = '';
            }
        });
        this.sortField = column;
        this.sortOrder = direction;
        this.loadData();
    }

    onSelect(selected) {
        console.log(selected.target.value);
        this.filterParams.page = 1;
        this.loadData();
    }

    onSelectOwned(selected) {
        console.log(selected.target.value);
        this.filterParams.page = 1;
        this.loadData();
    }


    ngOnInit(): void {
        this.filterParams.username = '';
        this.loadData();
    }

    loadData() {
        console.log(this.filterParams);
        this.apiModulesService.getData('telegram/user/list', this.filterParams, this.sortField, this.sortOrder, this.searchQuery)
            .subscribe((response: any) => {
                this.data = response.data;
                this.currentPage = response.current_page;
                this.total = response.total;
            });
    }

    clearFilter() {
        this.filterParams.page = 1;
        this.filterParams.username = '';
        this.filterParams.mobilenumber = '';
        this.filterParams.status = '';
        this.filterParams.blocked_messagec = '';
        this.filterParams.blocked_add_channel = '';
        this.loadData();
    }

    applySort() {
        this.loadData();
    }

    applySearch() {
        this.filterParams.page = 1;
        this.loadData();
    }


    /**
     * Write code on Method
     *
     * @return response()
     */
    pageChangeEvent(event: number) {
        this.currentPage = event;
        this.filterParams.page = this.currentPage;
        this.loadData();
    }

    public editUser(id) {
        this.editID = id;
        this.visible = false;
        this.visibleAdd = true;
    }

    public AddUser() {
        this.visibleAdd = false;
        this.visible = true;

        console.log(this.visibleAdd, this.visible);
    }


    childEmitted(data: any) {
        // console.log(data);
        this.visible = data;
        this.visibleAdd = data;
        this.loadData();

    }
}
